module.exports = __webpack_public_path__ + "img/li2.4a469650.png";